import i18next from 'i18next';

const PAYMENT_TYPES_MAPPER = {
  oneclick: 'Webpay OneClick',
  webpay: 'Webpay',
  sodexo: 'Sodexo',
  chek: 'Chek',
  mercadoPago: 'Mercado Pago',
  mach: 'Mach',
  kushkiCard: 'Crédito o débito (Kushki)',
  kushkiCardAsync: 'Crédito o débito (Kushki)',
  mercadoPagoCardPayment: 'Crédito o débito (Mercado Pago)',
  mercadoPagoCard: 'Crédito o débito (Mercado Pago)',
  mercadoPagoSubscriptionCardPayment: 'Tarjetas guardadas (Mercado Pago)',
  powertranzPayment: 'Powertranz',
  credomatic: 'Tarjeta de crédito (Credomatic)',
  getnet: 'Getnet',
  amipass: 'Amipass',
  fpay: 'Fpay',
  onvo: 'Onvo',
  sinpe: 'Sinpe',
  credit: 'Crédito',
  compra_click_bac: 'Compra Click BAC',
  noCharge: 'Sin cargo',
  powertranz: 'Credomatic',
  klapWallets: 'Google Pay / Apple Pay',
  klapSodexo: 'Pluxee',
  klapEdenred: 'Edenred'
};

i18next.addResources('es_CL', 'OrdersDetails', {
  address: 'Dirección',
  apartmentDetails: 'Dpto/Of./Casa',
  canceled: 'Cancelado',
  card: 'Tarjeta',
  cash: 'Efectivo',
  checkoutQuestions: 'Instrucciones adicionales',
  clientName: 'Cliente',
  deliveryConfirmationCode: 'Código Delivery',
  deliveryReferenceCode: 'Código de Uber',
  deliveryFee: 'Delivery',
  deliveryNotes: 'Instrucciones',
  deliveryOption: 'Tipo de entrega',
  details: 'Detalle pedido',
  couponDiscount: 'Descuento cupón',
  discountCoupon: 'Cupón de descuento',
  inStore: 'En tienda',
  in_store: 'En tienda',
  items: 'Items: {{length}}',
  laterStartTime: 'Fecha de entrega',
  OwnDelivery: 'Delivery propio',
  paid: 'Pagado',
  paymentMethod: 'Método de pago',
  PedidosYaDelivery: 'Delivery PedidosYa',
  pendingPayment: 'Por pagar',
  phone: 'Teléfono',
  pickUp: 'Retiro',
  pointsUsed: 'Descuento {{loyaltyProgramName}}',
  serviceFee: 'Servicio',
  storeDelivery: 'Delivery',
  store_delivery: 'Delivery',
  subtotal: 'Subtotal',
  tip: 'Propina',
  total: 'Total',
  totalCofinanced: 'Subvención delivery',
  totalWithTip: 'Total con propina',
  trackDelivery: 'Seguir pedido',
  UberDelivery: 'Delivery UberEats',
  oneClick: PAYMENT_TYPES_MAPPER.oneclick,
  OneclickPayment: PAYMENT_TYPES_MAPPER.oneclick,
  online: PAYMENT_TYPES_MAPPER.webpay,
  WebpayPayment: PAYMENT_TYPES_MAPPER.webpay,
  sodexo: PAYMENT_TYPES_MAPPER.sodexo,
  SodexoPayment: PAYMENT_TYPES_MAPPER.sodexo,
  ChekPayment: PAYMENT_TYPES_MAPPER.chek,
  chek: PAYMENT_TYPES_MAPPER.chek,
  MercadoPagoPayment: PAYMENT_TYPES_MAPPER.mercadoPago,
  mercadoPago: PAYMENT_TYPES_MAPPER.mercadoPago,
  MachPayment: PAYMENT_TYPES_MAPPER.mach,
  mach: PAYMENT_TYPES_MAPPER.mach,
  KushkiCardPayment: PAYMENT_TYPES_MAPPER.kushkiCard,
  kushkiCard: PAYMENT_TYPES_MAPPER.kushkiCard,
  KushkiCardAsyncPayment: PAYMENT_TYPES_MAPPER.kushkiCardAsync,
  kushkiCardAsync: PAYMENT_TYPES_MAPPER.kushkiCardAsync,
  KushkiCardAsyncSubscriptionPayment: PAYMENT_TYPES_MAPPER.kushkiCardAsync,
  KushkiCardSubscriptionPayment: PAYMENT_TYPES_MAPPER.kushkiCard,
  MercadoPagoCardPayment: PAYMENT_TYPES_MAPPER.mercadoPagoCardPayment,
  MercadoPagoSubscriptionCardPayment: PAYMENT_TYPES_MAPPER.mercadoPagoSubscriptionCardPayment,
  mercadoPagoCard: PAYMENT_TYPES_MAPPER.mercadoPagoCard,
  Credomatic: PAYMENT_TYPES_MAPPER.credomatic,
  GetnetPayment: PAYMENT_TYPES_MAPPER.getnet,
  AmipassPayment: PAYMENT_TYPES_MAPPER.amipass,
  FpayPayment: PAYMENT_TYPES_MAPPER.fpay,
  OnvoPayment: PAYMENT_TYPES_MAPPER.onvo,
  sinpe: PAYMENT_TYPES_MAPPER.sinpe,
  credit: PAYMENT_TYPES_MAPPER.credit,
  compra_click_bac: PAYMENT_TYPES_MAPPER.compra_click_bac,
  no_charge: PAYMENT_TYPES_MAPPER.noCharge,
  noCharge: PAYMENT_TYPES_MAPPER.noCharge,
  powertranz: PAYMENT_TYPES_MAPPER.powertranz,
  klapWallets: PAYMENT_TYPES_MAPPER.klapWallets,
  KlapWalletsPayment: PAYMENT_TYPES_MAPPER.klapWallets,
  klapSodexo: PAYMENT_TYPES_MAPPER.klapSodexo,
  KlapSodexoPayment: PAYMENT_TYPES_MAPPER.klapSodexo,
  klapEdenred: PAYMENT_TYPES_MAPPER.klapEdenred,
  KlapEdenredPayment: PAYMENT_TYPES_MAPPER.klapEdenred,
  channel: 'Canal',
  deliveryRejected: 'Delivery fue {{status}}.',
  assignNewDelivery: 'Asigna un nuevo delivery.',
  withProofOfDelivery: 'Prueba de entrega del pedido',
  withoutProofOfDelivery: 'Prueba de entrega',
  proofOfDeliveryMessage: 'Foto enviada por el repartidor',
  unavailable: 'No disponible',
  viewPhoto: 'Ver foto',
  aditionalInstructions: 'Comentarios:',
  uberDiscount: 'Descuento promo',
  createdAt: 'Fecha de creación',
  store: 'Tienda',
  posId: 'POS ID',
  businessEmail: 'Correo electrónico',
  businessName: 'Nombre',
  businessPhone: 'Teléfono',
  documentId: 'Identificación',
  documentType: 'Documento',
  billingInfo: 'Información de facturación',
  billingType: 'Tipo',
  ticket: 'Boleta',
  invoice: 'Factura',
  vat_number: 'RUT / RUN',
  identity_card: 'RUC'
});

i18next.addResources('es_CR', 'OrdersDetails', {
  address: 'Dirección',
  apartmentDetails: 'Dpto/Of./Casa',
  canceled: 'Cancelado',
  card: 'Tarjeta',
  cash: 'Efectivo',
  checkoutQuestions: 'Instrucciones adicionales',
  clientName: 'Cliente',
  deliveryConfirmationCode: 'Código Delivery',
  deliveryReferenceCode: 'Código de Uber',
  deliveryFee: 'Delivery',
  deliveryNotes: 'Instrucciones',
  deliveryOption: 'Tipo de entrega',
  details: 'Detalle pedido',
  couponDiscount: 'Descuento cupón',
  discountCoupon: 'Cupón de descuento',
  inStore: 'En tienda',
  in_store: 'En tienda',
  items: 'Items: {{length}}',
  laterStartTime: 'Fecha de entrega',
  OwnDelivery: 'Delivery propio',
  paid: 'Pagado',
  paymentMethod: 'Método de pago',
  PedidosYaDelivery: 'Delivery PedidosYa',
  pendingPayment: 'Por pagar',
  phone: 'Teléfono',
  pickUp: 'Retiro',
  pointsUsed: 'Descuento {{loyaltyProgramName}}',
  serviceFee: 'Servicio',
  storeDelivery: 'Delivery',
  store_delivery: 'Delivery',
  subtotal: 'Subtotal',
  tip: 'Propina',
  total: 'Total',
  totalCofinanced: 'Subvención delivery',
  totalWithTip: 'Total con propina',
  trackDelivery: 'Seguir pedido',
  UberDelivery: 'Delivery UberEats',
  oneClick: PAYMENT_TYPES_MAPPER.oneclick,
  OneclickPayment: PAYMENT_TYPES_MAPPER.oneclick,
  online: PAYMENT_TYPES_MAPPER.webpay,
  WebpayPayment: PAYMENT_TYPES_MAPPER.webpay,
  sodexo: PAYMENT_TYPES_MAPPER.sodexo,
  SodexoPayment: PAYMENT_TYPES_MAPPER.sodexo,
  ChekPayment: PAYMENT_TYPES_MAPPER.chek,
  chek: PAYMENT_TYPES_MAPPER.chek,
  MercadoPagoPayment: PAYMENT_TYPES_MAPPER.mercadoPago,
  mercadoPago: PAYMENT_TYPES_MAPPER.mercadoPago,
  MachPayment: PAYMENT_TYPES_MAPPER.mach,
  mach: PAYMENT_TYPES_MAPPER.mach,
  KushkiCardPayment: PAYMENT_TYPES_MAPPER.kushkiCard,
  kushkiCard: PAYMENT_TYPES_MAPPER.kushkiCard,
  KushkiCardAsyncPayment: PAYMENT_TYPES_MAPPER.kushkiCardAsync,
  kushkiCardAsync: PAYMENT_TYPES_MAPPER.kushkiCardAsync,
  KushkiCardAsyncSubscriptionPayment: PAYMENT_TYPES_MAPPER.kushkiCardAsync,
  KushkiCardSubscriptionPayment: PAYMENT_TYPES_MAPPER.kushkiCard,
  MercadoPagoCardPayment: PAYMENT_TYPES_MAPPER.mercadoPagoCardPayment,
  MercadoPagoSubscriptionCardPayment: PAYMENT_TYPES_MAPPER.mercadoPagoSubscriptionCardPayment,
  mercadoPagoCard: PAYMENT_TYPES_MAPPER.mercadoPagoCard,
  PowertranzPayment: PAYMENT_TYPES_MAPPER.powertranzPayment,
  powertranzPayment: PAYMENT_TYPES_MAPPER.powertranzPayment,
  Credomatic: PAYMENT_TYPES_MAPPER.credomatic,
  GetnetPayment: PAYMENT_TYPES_MAPPER.getnet,
  AmipassPayment: PAYMENT_TYPES_MAPPER.amipass,
  FpayPayment: PAYMENT_TYPES_MAPPER.fpay,
  sinpe: PAYMENT_TYPES_MAPPER.sinpe,
  credit: PAYMENT_TYPES_MAPPER.credit,
  compra_click_bac: PAYMENT_TYPES_MAPPER.compra_click_bac,
  no_charge: PAYMENT_TYPES_MAPPER.noCharge,
  noCharge: PAYMENT_TYPES_MAPPER.noCharge,
  powertranz: PAYMENT_TYPES_MAPPER.powertranz,
  klapWallets: PAYMENT_TYPES_MAPPER.klapWallets,
  KlapWalletsPayment: PAYMENT_TYPES_MAPPER.klapWallets,
  klapSodexo: PAYMENT_TYPES_MAPPER.klapSodexo,
  KlapSodexoPayment: PAYMENT_TYPES_MAPPER.klapSodexo,
  klapEdenred: PAYMENT_TYPES_MAPPER.klapEdenred,
  KlapEdenredPayment: PAYMENT_TYPES_MAPPER.klapEdenred,
  channel: 'Canal',
  deliveryRejected: 'Delivery fue {{status}}.',
  assignNewDelivery: 'Asigna un nuevo delivery.',
  withProofOfDelivery: 'Prueba de entrega del pedido',
  withoutProofOfDelivery: 'Prueba de entrega',
  proofOfDeliveryMessage: 'Foto enviada por el repartidor',
  unavailable: 'No disponible',
  viewPhoto: 'Ver foto',
  aditionalInstructions: 'Comentarios:',
  uberDiscount: 'Descuento promo',
  createdAt: 'Fecha de creación',
  store: 'Tienda',
  posId: 'POS ID',
  businessEmail: 'Correo electrónico',
  businessName: 'Nombre',
  businessPhone: 'Teléfono',
  documentId: 'Identificación',
  documentType: 'Documento',
  billingInfo: 'Información de facturación',
  billingType: 'Tipo',
  ticket: 'Ticket electrónico',
  invoice: 'Factura electrónica',
  identity_card: 'Cédula de identidad',
  vat_number: 'Cédula jurídica',
  taxFree: 'Esta orden está libre de impuestos',
  economicActivityCode: 'Actividad Económica'
});

// Only the keys whose wording differs from es_CL, the rest resolves through the es_CL fallback.
i18next.addResources('es_AR', 'OrdersDetails', {
  identity_card: 'DNI',
  vat_number: 'CUIT',
  ticket: 'Factura B',
  invoice: 'Factura A'
});
